<template>
    <div class="md:m-0 h-full flex-1 overflow-hidden">
        <div v-if="loading">
            <div class="flex items-center">
                <app-spinner class="text-gray-500" /> <span class="ml-3">Loading...</span>
            </div>
        </div>
        <table class="table" v-else>
            <tr>
                <td>Name </td>
                <td>{{ datacenter.name }}</td>
            </tr>
            <tr>
                <td>Datastore Folder</td>
                <td>{{ datacenter.datastore_folder }}</td>
            </tr>
            <tr>
                <td>Host Folder</td>
                <td>{{ datacenter.host_folder }}</td>
            </tr>
            <tr>
                <td>Network Folder </td>
                <td>{{ datacenter.network_folder }}</td>
            </tr>
            <tr>
                <td>Virtual Machine Folder </td>
                <td>{{ datacenter.vm_folder }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
    import Http from '@/helpers/Http';

    export default {
        data() {
            return {
                loading: false,
                dataStore: {}
            }
        },
        watch: {
            $route: {
                handler() {
                    this.init();
                },
                deep: true,
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.loading = true;
                Http.get(`vmware/vcenter/datastore/${this.$route.meta.id}`)
                    .then(({data}) => {
                        this.loading = false;
                        this.dataStore = data;
                    })
                    .catch(({response}) => {
                        this.loading = false;
                    });
            },

        }
    }
</script>